// Coordinate space of DmaPaths.json. The viewBox stays fixed to this so the paths scale to the
// rendered width/height.
export const MAP_WIDTH = 1100;
export const MAP_HEIGHT = 550;
export const MAP_VIEW_BOX = `0 0 ${MAP_WIDTH} ${MAP_HEIGHT}`;
export const MAP_ASPECT_RATIO = MAP_WIDTH / MAP_HEIGHT;

interface DMAPath {
  path: string;
  name: string;
}

// DmaPaths.json, keyed by Nielsen DMA code: each DMA's pre-projected SVG path and display name.
export type DMAPathMap = Record<string, DMAPath>;
